// @core/api/endpoints/project/get_timeline.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TimelineResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Get timeline view
 * Returns a Gantt-style timeline view of project items with their start dates, due dates, and dependencies for the specified date range.
 */
export async function GetTimeline(
  project_id: string,
  options?: RequestOptions
): Promise<TimelineResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/timeline`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.get<TimelineResponse>(requestPath, { ...requestOptions });
}
